<script>
import con from '@services/connection'
import { user } from '@constants/URL'
import Title from '@components/section-title'
import rules from '@constants/Rules'
import Vue from 'vue'
import store from '@state/store'
import { GlobalBus } from '@services/bus'
import { MODAL } from '@constants/Text'

const pagesToActions = {
  'carteira.minha': MODAL.MODAL_MY_WALLET,
  'carteira.minha.cliente': MODAL.MODAL_MY_WALLET,
  'carteira.analise': MODAL.MODAL_WALLET_ANALYSIS,
  'simulador.analise': MODAL.MODAL_SIMULATOR_ANALYSIS,
  'simulador.comparativo': MODAL.MODAL_SIMULATOR_COMPARE,
}

const pagesNames = {
  'carteira.minha': 'Consolidador > Carteira Atual',
  'carteira.minha.cliente': 'Consolidador > Carteira Atual',
  'carteira.analise': 'Consolidador > Análise de portfólio',
  'simulador.analise': 'Simulador > Análise',
  'simulador.comparativo': 'Simulador > Comparativo',
}

export default {
  components: {
    Title,
  },
  data() {
    return {
      busModal: new Vue(),
      loading: false,
      pagesNames: pagesNames,
      pageName: '',
      cliente: null,
      step: 1,
      message_text: '',
      token_sala: '',
      data_body: {},
      trigger_action: '',
      headers: [
        {
          text: 'Nome',
          value: 'nome',
        },
        {
          text: 'Descrição',
          value: 'descricao',
        },
        {
          text: 'Participantes',
          value: 'participantes',
        },
      ],
    }
  },
  created() {
    GlobalBus.$on(MODAL.WORKSPACE_SEND_COMPONENT, this.open)
  },
  beforeDestroy() {
    GlobalBus.$off(MODAL.WORKSPACE_SEND_COMPONENT, this.open)
  },
  methods: {
    open(opts, cliente) {
      this.clear()
      this.data_body = opts.data
      this.pageName = opts.page
      this.cliente = cliente
      this.trigger_action = pagesToActions[opts.page] || opts.page
      this.busModal.$emit('dialog', true)
    },
    clear() {
      this.loading = false
      this.step = 1
      this.message_text = ''
      this.token_sala = ''
      this.data_body = {}
      this.trigger_action = ''
    },
    async enviar() {
      if (this.loading) {
        return
      }
      this.loading = true
      this.$wsWorkspace.sendMessage({
        mensagem: this.message_text,
        token_sala: this.token_sala,
        trigger_action: this.trigger_action,
        body: this.data_body,
      })
      this.$showSnack({
        text: 'Mensagem enviada*',
        button: true,
      })
      this.loading = false
      this.busModal.$emit('dialog', false)
    },
    selectRoom(room) {
      this.token_sala = room.token_sala
      this.step = 2
    },
    openCreate() {
      GlobalBus.$emit(MODAL.CREATE_ROOM)
    },
  },
}
</script>

<template>
  <BaseModal :bus="busModal" max-width="900">
    <Title title="Enviar" />

    <p>
      Você está compatilhando a tela {{ pagesNames[pageName] }}, para cliente
      {{ cliente ? cliente.name : $currentClient().name }}
    </p>

    <div>
      <v-stepper v-model="step" class="elevation-0">
        <v-stepper-header hidden>
          <v-stepper-step step="1">Lista de salas</v-stepper-step>
          <v-stepper-step step="2">Mensagens</v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1">
            <v-data-table
              :items="$store.getters['chat/rooms']"
              :headers="headers"
              height="300"
              fixed-header
              class="row-pointer"
              @click:row="selectRoom"
            >
              <template v-slot:no-data>
                <div class="mt-5">
                  <p>Nenhum canal encontrado</p>
                  <BaseButton small primary @click="openCreate">
                    <strong>+</strong> Canal
                  </BaseButton>
                </div>
              </template>
              <template v-slot:item.participantes="{ item }">
                {{ item.participantes.join(', ') }}
              </template>
            </v-data-table>
          </v-stepper-content>
          <v-stepper-content step="2">
            <v-text-field v-model="message_text" label="Mensagem" />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>

    <template v-slot:actions="{ close }">
      <v-spacer />
      <BaseButton underlined @click="close">
        Cancelar
      </BaseButton>
      <BaseButton v-if="step == 2" primary :loading="loading" @click="enviar">
        Enviar
      </BaseButton>
      <v-spacer />
    </template>
  </BaseModal>
</template>

<style lang="sass" scope>
.row-pointer >>> tbody tr:hover
  cursor: pointer
</style>
